import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackQuoteDeletedParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/quote/trackQuoteDeleted";
import { PartialSpecific } from "@store/Framework/Types/Common";

const useTrackQuoteDeleted = (
    parameters: PartialSpecific<TrackQuoteDeletedParameters, "items"> = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    const hookParameters: TrackQuoteDeletedParameters = {
        ...ga.use.eventListParameters(options),
        ...parameters,
    };

    const hookOptions: Toolkit.GoogleAnalytics.Options = {
        quote: ga.use.quote(options),
        ...options,
    };

    return (parameters: Partial<TrackQuoteDeletedParameters> = {}, options?: Toolkit.GoogleAnalytics.Options) => {
        return ga.track.quoteDeleted({ ...hookParameters, ...parameters }, { ...hookOptions, ...options });
    };
};

export default useTrackQuoteDeleted;
